import { DownloadOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { useLazyVacationDownloadQuery } from 'app/services/edpApiV1/vacations';
import style from './index.module.scss';

const VacationDownload = ({ tabKey, disabled }: { tabKey: string; disabled: boolean }) => {
  const [vacationDownloadTrigger] = useLazyVacationDownloadQuery();

  const onDownload = () => {
    vacationDownloadTrigger({ type: tabKey });
  };

  return (
    <Button
      type="default"
      icon={<DownloadOutlined />}
      className={style.BtnDownload}
      onClick={() => onDownload()}
      disabled={disabled}
    >
      Скачать
    </Button>
  );
};

export default VacationDownload;
